import { MapContainer, TileLayer, CircleMarker, Popup, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { LOCATIONS, TYPE_COLOR } from "@/data/storeLocations";

export const StoreMap = () => (
  <div className="relative w-full h-[480px] md:h-[600px] overflow-hidden border border-[#F7F2E9]/15" data-testid="store-map">
    <MapContainer center={[9.58, 76.66]} zoom={10} scrollWheelZoom={false} style={{ height: "100%", width: "100%", background: "#371D00" }}>
      <TileLayer
        attribution='&copy; OpenStreetMap contributors &copy; CARTO'
        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
      />
      {LOCATIONS.map((s, i) => (
        <CircleMarker
          key={`${s.name}-${i}`}
          center={s.pos}
          radius={9}
          pathOptions={{ color: "#FBDE08", fillColor: TYPE_COLOR[s.type] || "#EF1221", fillOpacity: 0.92, weight: 2 }}
        >
          <Tooltip direction="top" offset={[0, -6]} opacity={1}>
            <span style={{ fontWeight: 600 }}>{s.name} · {s.town}</span>
          </Tooltip>
          <Popup>
            <div style={{ fontFamily: "Inter, sans-serif", minWidth: 180 }}>
              <strong style={{ color: TYPE_COLOR[s.type] || "#EF1221" }}>{s.name}</strong>
              <div style={{ fontSize: 11, letterSpacing: "0.1em", textTransform: "uppercase", color: "#888", margin: "2px 0 6px" }}>{s.type} · {s.town}</div>
              <div style={{ color: "#371D00", fontSize: 13 }}>{s.address}</div>
              <div style={{ marginTop: 6, fontSize: 13 }}>
                {s.phones.map((p) => (
                  <a key={p} href={`tel:${p.replace(/\s/g, "")}`} style={{ color: "#EF1221", display: "block", textDecoration: "none" }}>{p}</a>
                ))}
              </div>
            </div>
          </Popup>
        </CircleMarker>
      ))}
    </MapContainer>
  </div>
);

export default StoreMap;
